import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { isPhone } from '@helpers';
import Button from '@styles/buttons';

import type { TeamStepProps } from '@components/tenantStatus/onboardingWizard/types';
import Dropdown from '@components/common/dropdown';
import WizardInput from '@components/tenantStatus/onboardingWizard/components/WizardInput';
import { useManageTeamStep } from './hooks/useManageTeamStep';

const TeamStep = ({ C, data, onChange }: TeamStepProps) => {
  const { handleRowChange, handleAdd, roleItems } = useManageTeamStep({ data, onChange });

  return (
    <View>
      <Text style={[font['Title 2'], { color: C('Label/Light/Primary'), marginBottom: scale(20) }]}>
        {i18n.t('Your Team')}
      </Text>
      <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary') }]}>{i18n.t('Team members')}</Text>
      <Text style={[font['Footnote'], { color: C('Label/Light/Tertiary'), marginBottom: scale(12) }]}>
        {i18n.t('Optional — invite colleagues')}
      </Text>

      {data.members.map((member, index) => (
        <View
          key={index}
          style={{
            flexDirection: isPhone ? 'column' : 'row',
            alignItems: isPhone ? 'stretch' : 'center',
            marginBottom: scale(12),
          }}
        >
          <WizardInput
            C={C}
            value={member.email}
            onChangeText={(email) => handleRowChange(index, { email })}
            placeholder={i18n.t('Email address')}
            keyboardType="email-address"
            autoCapitalize="none"
            testID={`onboarding-wizard-team-email-${index}`}
            containerStyle={{
              flex: isPhone ? undefined : 1,
              marginRight: isPhone ? 0 : scale(8),
              marginBottom: isPhone ? scale(8) : 0,
            }}
          />
          <View style={{ minWidth: scale(160) }}>
            <Dropdown
              C={C}
              items={roleItems}
              selectedValue={member.role}
              onChange={(value) => handleRowChange(index, { role: value })}
              testID={`onboarding-wizard-team-role-${index}`}
            />
          </View>
        </View>
      ))}

      <View style={{ alignSelf: 'flex-start', marginTop: scale(4) }}>
        <Button
          variant="L"
          type="Only Text"
          onPress={handleAdd}
          testID="onboarding-wizard-team-add"
          colors={{
            bgColor: 'Button / Light / Only Text',
            textColor: 'Other/Light/Logo/Smart',
          }}
        >
          {i18n.t('+ Add team member')}
        </Button>
      </View>
    </View>
  );
};

export default TeamStep;
